import '../common/polyfills';
import carousel from '../common/carousel';
import lazyLoadImages from '../common/lazy-load';
import setDate from '../common/date';
import email from '../common/email';
import comments from '../common/comments';
import loadJson from './modules/json-content';
import topicAlert from './modules/topic-alert';
import actions from './modules/actions';
import poll from '../common/poll';
import committee from './modules/committee';
import tracking from '../common/tracking';
import ad from './modules/ad';
import ads from '../common/ads';
import _ from '../common/utility';
import objectFitImages from 'object-fit-images';
import news from '../common/news';
import setHeaderBackground from './modules/clinical-collection';
import recapCarousel from './modules/recap';
import featuredCarousel from './modules/featured';
import injectIFIContainerManual2Col from './modules/manual2col';
import adCOE from './modules/coe-ads';
import coeHub from './modules/coe-hub';
import bucketsMenu from './modules/coe-buckets-menu';
import loadCOEJson from './modules/coe-json-content';
import setCoeRightRailStickyPos from './modules/set-coe-right-rail-sticky-pos';

$(() => {

    _.initJQueryPlugin();
    if (_.isCOE() && $(".coe-v2").length > 0) {
        loadCOEJson(lazyLoadImages);
    } else {
        loadJson(lazyLoadImages);
    }
    ad();
    carousel();
	lazyLoadImages();
    setDate();
    topicAlert();
    email();
    actions();
    comments();
    poll();
    committee();
    tracking();
    objectFitImages('img');
	news();
    setHeaderBackground();
    recapCarousel();
    featuredCarousel();
    injectIFIContainerManual2Col();
    adCOE();
    coeHub();
	if (_.isRC()) {
		ads();
	}
    bucketsMenu();
    setCoeRightRailStickyPos();
});

// add 1122 ad before DOM ready to prevent extra ad display calls
// there will be an ajax-injected section, so append ad after the 1st section in current dom
if (_.getBreakpoint() === 1 && document.getElementById('ads-pos-1520') === null && typeof isCC != "undefined" && isCC) {
    $('main section').eq(0).after(`
        <div id="ads-pos-1520" class="AdUnit"></div>
        <script>                               
            webmd.ads2.defineAd({              
            id: 'ads-pos-1520',          
            pos: 1520                     
            });                                
        </script>`);
}

if (_.getBreakpoint() === 1 && document.getElementById('ads-pos-1122') === null && typeof isCC != "undefined" && isCC) {
    $('main section').eq(3).after(`
        <div id="ads-pos-1122" class="AdUnit"></div>
        <script>                               
            webmd.ads2.defineAd({              
            id: 'ads-pos-1122',          
            pos: 1122                     
            });                                
        </script>`);
}

if (_.getBreakpoint() === 1 && document.getElementById('ads-pos-1122') === null && typeof isCOE != "undefined" && isCOE) {
    let tarEle = $('.coe-v2').length > 0 ? '.hp_bucket2col[data-track=coe-quiz]' : 'main section';
    let adPosHtml = `
    <div id="ads-pos-1122" class="AdUnit"></div>
    <script>
        webmd.ads2.defineAd({
        id: 'ads-pos-1122',
        pos: 1122
        }); 
    </script>`;

    if ($('.coe-v2').length > 0) $(tarEle).eq(0).before(adPosHtml);
    else $(tarEle).eq(0).after(adPosHtml);
}

//Adding Ads at 622,722 and 1622 for Asthma resource centre (window.DFPTargetKeys.pageSegVars.art == '35061')
$(document).ready(function(){
if(window.DFPTargetKeys.pageSegVars.art == '35061'){
    var li622 = `<li id="ads-pos-622" class="AdUnit"></li>`;
    var li722 = `<li id="ads-pos-722" class="AdUnit"></li>`;
    var li1622 = `<li id="ads-pos-1622" class="AdUnit"></li>`;
    if(window.DFPTargetKeys.reqHeaders.device == 'PC' || window.DFPTargetKeys.reqHeaders.device == 'IPAD'){
        $('.articles.column1 li').eq(1).after(li722);
        $('.column2 li').eq(0).before(li622);
        webmd.ads2.defineAd({
            id:'ads-pos-622',
            pos:622
        });
        webmd.ads2.defineAd({
            id:'ads-pos-722',
            pos:722
        })
    }else if(window.DFPTargetKeys.reqHeaders.device == 'MOBILE'){
        $('.articles li').eq(2).after(li1622);
        webmd.ads2.defineAd({
            id:'ads-pos-1622',
            pos:1622
        })
    }
 
}
})